window.initGooglePlace = function() {

    let options = {
        types: ['(cities)'],
        componentRestrictions: {country: 'us'}
    };

    let $googleplaces = $('input[data-component="googleplace"]');

    $googleplaces.each((key, input) => {
        if($(input).data('initialized') === undefined){

            if($(input).data('type') === 'geocode'){
                // allows searching for residential addresses
                options.types = ['geocode'];
            }

            let autocomplete = new google.maps.places.Autocomplete(input, options);
            autocomplete.addListener('place_changed', () => {

                let place = autocomplete.getPlace();
                let value = autocomplete.value;
                let latlng = place.geometry.location;
                let data = {"value": value, "latlng": latlng};

                for (let i = 0; i < place.address_components.length; i++) {
                    let addressType = place.address_components[i].types[0];
                    data[addressType] = place.address_components[i]['long_name'];
                }

                let $form = $(input).closest('form');

                // custom js for the project
                $form.find('input[name="googleplace_city"]').val(data.locality);
                $form.find('input[name="googleplace_state"]').val(data.administrative_area_level_1);
                $form.find('input[name="googleplace_country"]').val(data.country);
                $form.find('input[name="googleplace_zip_code"]').val(data.postal_code);
                $form.find('input[name="googleplace_latitude"]').val(data.latlng.lat);
                $form.find('input[name="googleplace_longitude"]').val(data.latlng.lng);

                if(data.street_number && data.route){
                    $form.find('input[name="address_line_1"]').val(data.street_number + ' ' + data.route);
                    $form.find('input[name="location"]').val(data.street_number + ' ' + data.route);
                }
            });

            $(input).data('initialized', true);

            $(input).on('keydown', function() {
                $('input[name="googleplace_city"]').val('');
                $('input[name="googleplace_state"]').val('');
                $('input[name="googleplace_country"]').val('');
                $('input[name="googleplace_zip_code"]').val('');
                $('input[name="googleplace_latitude"]').val('');
                $('input[name="googleplace_longitude"]').val('');
            });
        }

    });

};

initGooglePlace();